import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import AISvg from 'components/shared/svg/AISvg';

const ModalHeader = ({ title, subheader }) => {
  return (
    <>
      <div className="mb-8">
        <Text variant={TEXT_VARIANTS.TITLE}>
          <AISvg className="generate-svg" />
          {title}
        </Text>
      </div>
      <div className="mb-16">
        <Text variant={TEXT_VARIANTS.BODY_LIGHT}>{subheader}</Text>
      </div>
    </>
  );
};

export default ModalHeader;
